import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import {
  defaultDate
} from "../../../utils/convertTime";
import {getCurrencyValue, getLabelWithMetric} from "../../../services/restaurant";
import { getTimePerDay } from '../../../services/userModel.js';

const ShiftsHistorySummary = ({ t, shiftsHistory }) => {
  const { startDate, endDate } = shiftsHistory || {};
  const { totalAmount, ordersDelivered, cashCollected, distanceTraveled } =
    shiftsHistory && shiftsHistory.statistics ? shiftsHistory.statistics : {};
  const getStatisticCreditCard = () => {
    if (!shiftsHistory || !shiftsHistory.statistics) return 0;
    return parseFloat((totalAmount - cashCollected).toFixed(2)) || 0;
  };
  const getShiftTime = () => {
    if (!startDate) return "";
    const startShiftDate = new Date(startDate);
    if (!endDate) {
      if (startShiftDate.getTime() !== new Date(defaultDate).getTime()) {
        return getTimePerDay({startDate: startShiftDate, endDate: Date.now()});
      }
    } else {
      const endShiftDate = new Date(endDate);
      return getTimePerDay({startDate: startShiftDate, endDate: endShiftDate});
    }
    return "";
  };
  const getDistance = () => {
    let result;
    if (distanceTraveled) {
      result = Math.round(distanceTraveled / 100) / 10;
    } else {
      result = "0.0";
    }
    return result;
  };

  return (
    <div className={classNames("shiftsHistorySummary")}>
      <table>
        <tbody>
          <tr>
            <td>
              <div className={classNames("title")}>
                <div className={classNames("icon", "ordersDelivered")} />
                {ordersDelivered || 0}
              </div>
              <div className={classNames("info")}>
                {t("couriers.ORDERS_DELIVERED_STATISTIC")}
              </div>
            </td>
            <td>
              <div className={classNames("title")}>
                <div className={classNames("icon", "distanceCovered")} />
                {getDistance()}
                <span className={classNames("smallText")}>
                  {t(getLabelWithMetric("couriers.DISTANCE_LABEL"))}
                </span>
              </div>
              <div className={classNames("info")}>
                {t(getLabelWithMetric("couriers.DISTANCE_COVERED_STATISTIC"))}
              </div>
            </td>
            <td>
              <div className={classNames("title")}>
                <div className={classNames("icon", "cashCollected")} />
                {cashCollected.toFixed(1) || 0}
                <span className={classNames("smallText")}>
                  {getCurrencyValue()}
                </span>
              </div>
              <div className={classNames("info")}>
                {t("couriers.CASH_STATISTIC_STATISTIC")}
              </div>
            </td>
            <td>
              <div className={classNames("title")}>
                <div className={classNames("icon", "creditCard")} />
                {getStatisticCreditCard()}
                <span className={classNames("smallText")}>
                  {getCurrencyValue()}
                </span>
              </div>
              <div className={classNames("info")}>
                {t("couriers.CREDIT_CARD_STATISTIC")}
              </div>
            </td>
            <td>
              <div className={classNames("title")}>
                <div className={classNames("icon", "shiftTime")} />
                {getShiftTime()} {t('covertTime.TIME_HOUR')}
              </div>
              <div className={classNames("info")}>
                {t("couriers.SHIFT_TIME_STATISTIC")}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  shiftsHistory: state.restaurant.data.shiftsHistory || []
});

export default connect(mapStateToProps)(
  withTranslation()(ShiftsHistorySummary)
);
